import { render, staticRenderFns } from "./PopUpAiAssistant.vue?vue&type=template&id=333b9f58&scoped=true"
import script from "./PopUpAiAssistant.vue?vue&type=script&lang=js"
export * from "./PopUpAiAssistant.vue?vue&type=script&lang=js"
import style0 from "./PopUpAiAssistant.vue?vue&type=style&index=0&id=333b9f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b9f58",
  null
  
)

export default component.exports